export default __webpack_public_path__ + "static/media/employee-directory.b7bf368b.png";